export function generateDownloadFileLink(file: Blob, fileName: string): void {
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(file);
  link.download = fileName;

  link.click();
  link.remove();
}
